import { print } from 'graphql';
import authorizationHeader from '../../../shared/services/authorizationHeader';
import { RELEASE_CONTRACT_TEMPLATE_LOCK } from '../api/contractTemplates';

// RITA-1541: Freigabe der eigenen Sperre beim Schließen des Fensters (pagehide). Der Apollo-Client
// ist in diesem Moment nicht mehr verlässlich; ein `fetch` mit `keepalive` an dieselbe Adresse
// (`/backend`, wie der Client in ErrorMessage.tsx) darf den Seitenwechsel überdauern. Gelingt es
// nicht, läuft die Sperre serverseitig nach 30 Minuten ohne Eingabe ab.
export const GRAPHQL_ADRESSE = '/backend';

export function sperreBeimSchliessenFreigeben(vorlagenId: number, token: string): boolean {
  if (typeof fetch !== 'function') return false;
  try {
    fetch(GRAPHQL_ADRESSE, {
      method: 'POST',
      keepalive: true,
      headers: { 'content-type': 'application/json', ...authorizationHeader() },
      body: JSON.stringify({
        operationName: 'releaseContractTemplateLock',
        query: print(RELEASE_CONTRACT_TEMPLATE_LOCK),
        variables: { id: vorlagenId, token },
      }),
    }).catch(() => undefined);
    return true;
  } catch {
    return false;
  }
}
